import { MotifToast } from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import { GLOBAL_NOTIFICATION } from "../../Constant";
import "./NotificationGrid.scss";
type Variant = "error" | "success" | "info" | "warning";

type NotificationProps = {
  show?: boolean;
  message?: string;
  type?: Variant;
  supportingText?: string;
  scrollToTop?: boolean;
  onCloseHandler?: () => void;
  subMessage?: string;
};

export default function NotificationGrid({
  show = true,
  message = "",
  type = "error",
  supportingText = "",
  subMessage = "",
  onCloseHandler,
}: NotificationProps) {
  const [showMessage, setShowMessage] = useState({
    show: show,
    type: type,
    message: message,
    supportingText: supportingText,
  });

  const closeMessageHandler = () => {
    if (onCloseHandler) {
      onCloseHandler();
    }
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);

  const notificationMessage =
    type === "error"
      ? message === ""
        ? GLOBAL_NOTIFICATION.UNEXPECTED_ERROR
        : message
      : message === ""
      ? GLOBAL_NOTIFICATION.UPDATED_SUCCESSFULLY
      : message;
  if (!showMessage.show) {
    return null;
  }

  return (
    <>
      <MotifToast
        onClose={closeMessageHandler}
        variant={showMessage.type as Variant}
        supportingText={showMessage.supportingText}
      >
        <div className={subMessage ? "toast-message" : ""}>
          {notificationMessage}
        </div>
        {subMessage && <span className="toast-submessage">{subMessage}</span>}
      </MotifToast>
    </>
  );
}
